$(document).ready(function () {
  $(".qtyplus")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      var $this = $(this),
        $input = $this.prev("input"),
        newValue = parseInt($input.val()) + 1;
      console.log(newValue);
      $input.val(newValue);
      $input.attr("value", newValue);
      //           console.log($input.val(newValue));
      $this.prev("input").trigger("change");
      var final = 0;
      $this
        .closest("form")
        .find('.variant-list input[type="number"]')
        .each(function () {
          var val = $(this).val();

          console.log(val);

          final = parseInt(final) + parseInt(val);
        });
      var price = $(this)
        .closest("form")
        .find(".active-price .origin-price")
        .attr("data-price");
      var total_price = parseInt(price) * final;
      console.log(total_price / 100, "total_price");
      if (final > 0) {
        $(this)
          .closest("form")
          .find(".active-price .origin-price span")
          .text("$" + total_price / 100);
        //  $('.scc1').text('$'+total_price/100);
        //  $('.scc2').text('$'+(total_price/100/7).toFixed(2));
      }
      if (final == 7) {
        $(".variants_addcart_1").removeClass("disabled").removeAttr("disabled");
      } else {
        $(".variants_addcart_1")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final < 7) {
        console.log("yess");
        $(".variants_addcart_2")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final >= 7) {
        $(".variants_addcart_2").removeClass("disabled").removeAttr("disabled");
      }
      if (final > 13) {
        $(".variants_addcart_2")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }

      if (final < 14) {
        $(".variants_addcart_3")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final >= 14) {
        $(".variants_addcart_3").removeClass("disabled").removeAttr("disabled");
      }
      if (final > 29) {
        $(".variants_addcart_3")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }

      if (final >= 30) {
        $(".variants_addcart_4").removeClass("disabled").removeAttr("disabled");
      } else {
        $(".variants_addcart_4")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
    });

  $(".qtyminus")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      var $this = $(this),
        $input = $this.next("input"),
        newValue = parseInt($input.val()) - 1;
      if (newValue < 0) {
        $input.val(0);
      } else {
        $input.val(newValue);
        $input.attr("value", newValue);
        $this.next("input").trigger("change");
      }

      var final = 0;
      $this
        .closest("form")
        .find('.variant-list input[type="number"]')
        .each(function () {
          var val = $(this).val();

          console.log(val);

          final = parseInt(final) + parseInt(val);
        });
      var price = $(this)
        .closest("form")
        .find(".active-price .origin-price")
        .attr("data-price");
      var total_price = parseInt(price) * final;
      if (final > 0) {
        $(this)
          .closest("form")
          .find(".active-price .origin-price span")
          .text("$" + total_price / 100);
        // $('.scc1').text('$'+total_price/100);
        //  $('.scc2').text('$'+(total_price/100/7).toFixed(2));
      }
      if (final == 7) {
        $(".variants_addcart_1").removeClass("disabled").removeAttr("disabled");
      } else {
        $(".variants_addcart_1")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final < 7) {
        $(".variants_addcart_2")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final >= 7) {
        $(".variants_addcart_2").removeClass("disabled").removeAttr("disabled");
      }
      if (final > 13) {
        $(".variants_addcart_2")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }

      if (final < 14) {
        $(".variants_addcart_3")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
      if (final >= 14) {
        $(".variants_addcart_3").removeClass("disabled").removeAttr("disabled");
      }
      if (final > 29) {
        $(".variants_addcart_3")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }

      if (final >= 30) {
        $(".variants_addcart_4").removeClass("disabled").removeAttr("disabled");
      } else {
        $(".variants_addcart_4")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
    });

  $(".product-select-btn span").click(function () {
    $(".product-select-btn span").removeClass("active").text("Select");
    $(".select-product").removeClass("active-container");
    $(this)
      .addClass("active")
      .closest(".select-product")
      .addClass("active-container");
    $(this).text("Selected");
    $(".price_varis .subscription-price")
      .removeClass("active-price")
      .addClass("hide");
    $(".price_varis .onetime-price")
      .addClass("active-price")
      .removeClass("hide");

    var handle = $(this).attr("data-product-handle");
    $(".bundle-product-variants").hide().removeClass("active-variant");
    $("." + handle)
      .show()
      .addClass("active-variant");
    var data_id = $(this).attr("data-id");
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $("#" + data_id).offset().top - 200,
        },
        2000
      );
    }, 300);
  });
});
$('input[type="radio"').click(function () {
  var new_href = $(this).next("a").attr("href");
  $(".button.inverse").attr("href", new_href);
});

$(".variant-list img").click(function () {
  $(".product_popup").removeClass("popup-active");
  $(this)
    .parents(".variant-list-wrapper")
    .find(".product_popup")
    .removeClass("hide")
    .addClass("popup-active");
  $("body").addClass("open-popup");
});

$(".popup-close").click(function () {
  $(this).parents().find(".product_popup").removeClass("popup-active");
  $("body").removeClass("open-popup");
});
